import { Helper } from "../Utils/Helper";

export default class MyMIPASettingobj{
    public CategoryList:Array<ListCategory>;
    public ListInfo:Array<MSListConfig>;
    public Sacratary:ManagerInfo;
    public Managers:Array<ManagerInfo>;
    public Me:ManagerInfo;
    public constructor(){
        this.CategoryList=[];
        this.ListInfo=[];
        this.Sacratary=new ManagerInfo();
        this.Managers=[];
        this.Me=new ManagerInfo();
    }
}
 export class ListCategory{
    public  ID:string;
    public  CategoryName:string;
    public  ColorHex:string;
    public  NoOfList:Number;
    public constructor(){
        this.CategoryName='';
        this.ColorHex='';
        this.NoOfList=0;
    }
}
 export class MSListConfig{
    public  ID:string;
    public  SiteURL:string;
    public  ListTitle:string;
    public  CategoryId:string;
    public  Category:ListCategory;
    public  DisplayFields:Array<MSListFiled>;
    public  EditFields:Array<MSListFiled>;
    public  AllFields:Array<MSListFiled>;    
    public  Heading:string;
    
    public  Query:string;
    public  DateField:MSListFiled;
    public  FlagField:MSListFiled;  
    public  UserField:MSListFiled;      
    public  Token:string;
    public  CurrentUserId:Number;
    public  UserEmail:string;

    public constructor (){
        this.ID=Helper.newguid();
        this.SiteURL='';
        this.ListTitle='';
        this.CategoryId='';
        this.DisplayFields=[];
        this.EditFields=[];
        this.AllFields=[];
        this.DateField=new MSListFiled();
        this.FlagField=new MSListFiled();  
        this.UserField=new MSListFiled();  
    }
}
export class ManagerInfo{
    public UserID:string;
    public Name:string;
    public Email:string;   
    public SiteUrl:string; 
    public constructor(){
        this.UserID='';
        this.Name='';
        this.Email='';
        this.SiteUrl='';
    }       
}
export class MSListFiled{
    public  ID:string;
    public  Name:string;
    public  Title:string;
    public  Type:string;
    public  Value:string;   
    public  Operator:string;
    public  Choices: Array<string>;
    public  CurrentUserId:Number;
    public Sequence:number;
    public ShowInCard:boolean;
    public  ShowInDetails:boolean
    public constructor(){
        this.Name='';
        this.Title='';
        this.Type='';
        this.Value='';
        this.Operator='';
        this.Sequence=0;
        this.ShowInCard=true;
        this.ShowInDetails=false;
    }
}
export class MSListItem{
    public  ID:number;
        public  Category:string;
        public  Color:string;
        public  SiteUrl:string;
        public  ListTitle:string;
        public Fields:Array<MSListFieldValue>;
        public  Col:number;
}
export class MSListFieldValue{
    public  FieldTitle:string;
    public  FieldName:string;
    public  FieldValue:string;
    public  FieldType:string;
    public LookUpId?:string;
    public IDValue:number;
    public ShowInCard?:boolean;
    public  ShowInDetails?:boolean
}